<template>
  <ul :class="filtersCssClasses">
    <search-filter
      v-for="filter in filters"
      :key="filter.name"
      :css-prefix="cssPrefix"
      :name="filter.name"
      :value="filter.filterValue"
      :selected="selectedFilterValue === filter.filterValue"
      @filter-click="onFilterClick"
    />
  </ul>
</template>

<script>
  import SearchFilter from './filter';

  export default {
    components: {
      SearchFilter
    },
    props: {
      cssPrefix: { type: String, required: true }
    },
    data() {
      return {
        selectedFilterValue: '',
        filters: [
          {
            name: 'All Results',
            filterValue: ''
          },
          {
            name: 'Products',
            filterValue: `(page_type:spree_product,
            page_type:spree_taxon,
            page_type:spree_taxonomy)`
          },
          {
            name: 'Resources',
            filterValue: '(page_type:alchemy_page, page_type:zendesk_article)'
          }
        ]
      }
    },
    computed: {
      filtersCssClasses() {
        return `${this.cssPrefix}-filters`
      }
    },
    methods: {
      onClickBackgroundFreezer(event) {
        if (event.target.className.match(/background-freezer/)) {
          this.$emit('click-away')
        }
      },
      onFilterClick(filterValue) {
        this.selectedFilterValue = filterValue;
        this.$emit('change', filterValue);
      }
    }
  };
</script>
